import { ApiBaseResponse } from "../api-base-model";

export enum SessionStatus {
    ALL = 'all',
    PENDING_PAYMENT = 'pending_payment',
    AWAITING_ACCEPTANCE = 'awaiting_acceptance',
    ACCEPTED = 'accepted',
    COMPLETED = 'completed',
    REJECTED = 'rejected',
    CANCELLED = 'cancelled',
    CANCELLED_BY_MENTOR = 'cancelled_by_mentor',
    CANCELLED_BY_STUDENT = 'cancelled_by_student',
    EXPIRED = 'expired',
    WAITING = 'waiting',
    COMPLETE = 'complete',
    REFUND_PROCESSING = 'refund_processing',
    REFUNDED = 'refunded',
    MISSED_SESSION = 'Missed Session'
}

export interface MentorDashboardStatsRequest {
    mentor_id?: string;
}

export interface MentorDashboardStatsDataResponse {
    pending_requests: number;
    upcoming_sessions: number;
    completed_sessions: number;
    total_sessions: number;
    average_rating: number | string;
}

export interface MentorDashboardStatsResponse extends ApiBaseResponse {
    Data: MentorDashboardStatsDataResponse;
}

export interface MentorSessionHistoryRequest {
    filter?: SessionStatus;
    page?: number;
    limit?: number;
    mentor_id?: string;
}

export interface MentorSessionHistoryItem {
    student_initials: string;
    student_name: string;
    date: string;
    duration: string;
    topic: string;
    status: SessionStatus;
    rating: number | null;
}

export interface MentorSessionHistoryDataResponse {
    sessions: MentorSessionHistoryItem[];
    total_count: number;
    page: number;
    limit: number;
    total_pages: number;
}

export interface MentorSessionHistoryResponse extends ApiBaseResponse {
    Data: MentorSessionHistoryDataResponse;
}

export interface UpdateBookingStatusRequest {
    action: boolean;
    mentor_id?: string;
}

export interface UpdateBookingStatusDataResponse {
    booking_id: string;
    status: string;
}

export interface UpdateBookingStatusResponse extends ApiBaseResponse {
    Data: UpdateBookingStatusDataResponse;
}

export interface UpcomingSessionsRequest {
    mentor_id?: string;
}

export interface UpcomingSessionItem {
    booking_id: string;
    mentor_name: string;
    student_name: string;
    session_type: string;
    date: string;
    start_time_utc: string;
    end_time_utc: string;
    duration_minutes: number;
    google_meet_link: string | null;
    status: string;
}

export interface UpcomingSessionsDataResponse {
    sessions: UpcomingSessionItem[];
}

export interface UpcomingSessionsResponse extends ApiBaseResponse {
    Data: UpcomingSessionsDataResponse;
}

export interface MentorBookingsRequest {
    mentor_id?: string;
}

export interface MentorBookingItem {
    booking_id: string;
    student_name: string;
    student_email: string;
    appointment_date: string;
    start_time: string;
    end_time: string;
    duration_minutes: number;
    appointment_type: string;
    topics: string;
    status: SessionStatus;
    google_meet_link: string | null;
    is_free: boolean;
}

export interface MentorBookingsDataResponse {
    pending_requests_count: number;
    bookings: MentorBookingItem[];
}

export interface MentorBookingsResponse extends ApiBaseResponse {
    Data: MentorBookingsDataResponse;
}
export interface UpdateStatusRequest {
    action: 'accept' | 'reject';
    mentor_id?: string;
}

export interface UpdateStatusResponse extends ApiBaseResponse {
    Data: any;
}

export interface CompleteBookingDataResponse {
    booking_id: string;
    status: string;
}

export interface CompleteBookingResponse extends ApiBaseResponse {
    Data: CompleteBookingDataResponse;
}

export interface MentorStat {
    label: string;
    count: string | number;
    icon: string;
    colorClass: string;
}

export interface MentorSessionRequest {
    id: string;
    studentName: string;
    initials: string;
    date: string;
    time: string;
    duration: string;
    topic: string;
    status: SessionStatus;
    category: 'FREE' | 'PAID';
    avatarColorClass: string;
}

export interface MentorUpcomingSession {
    id: string;
    studentName: string;
    initials: string;
    sessionType: string;
    topic: string;
    date: string;
    time: string;
    duration: string;
    isToday: boolean;
    status?: string;
    type: 'FREE' | 'PAID';
    avatarColorClass: string;
    googleMeetLink?: string | null;
}

export interface MentorHistoryRecord {
    id: string;
    studentName: string;
    initials: string;
    date: string;
    duration: string;
    topic: string;
    status: SessionStatus;
    rating: string | null;
    avatarColorClass: string;
}   
